import { parse } from 'query-string';
import { path } from 'ramda';
import { useRouter } from '../routes/index';

function useParams() {
  const { location } = useRouter();
  const params: any = parse(path(['search'], location));
  return params;
}

export default useParams;
